export const COOKIE_GDPRC = "gdprc";

export const SCREEN_XXS = 375;
export const SCREEN_XXS_MAX = SCREEN_XXS - 1;
export const SCREEN_XS = 480;
export const SCREEN_XS_MAX = SCREEN_XS - 1;
export const SCREEN_SM = 768;
export const SCREEN_SM_MAX = SCREEN_SM - 1;
export const SCREEN_MD = 992;
export const SCREEN_MD_MAX = SCREEN_MD - 1;
export const SCREEN_LG = 1200;
export const SCREEN_LG_MAX = SCREEN_LG - 1;
export const SCREEN_XL = 1440;
export const SCREEN_XL_MAX = SCREEN_XL - 1;
